import { styled } from "@mui/material";

export const TeamEquipmentComponent = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alingItems: "center",
  gap: "4px",

  width: "100%",
  padding: "0 4px",
}));
